export default {
  privacy: {
    badge: 'PRIVACY',
    title: 'Privacy Policy',
    updated: 'Last updated: September 2026',
    sections: [
      {
        title: '1. Data Controller',
        blocks: [
          { type: 'p', text: 'This privacy policy explains how Limpia Sàrl processes the personal data of visitors to its website and its clients.' },
          { type: 'p', text: 'Limpia Sàrl — Rte de Rosé 51, 1754 Avry-sur-Matran, Switzerland' },
          { type: 'p', text: 'IDE/VAT: CHE-427.499.887' },
          { type: 'p', text: 'For any questions regarding data protection, you can contact us at the email address provided on our website.' },
        ],
      },
      {
        title: '2. Personal Data Collected',
        blocks: [
          { type: 'p', text: 'When you use our website, we may process the personal data you voluntarily provide to us, in particular when you:' },
          { type: 'li', text: 'contact us by email;' },
          { type: 'li', text: 'use our contact form;' },
          { type: 'li', text: 'request an offer or quote;' },
          { type: 'li', text: 'request information about our services;' },
          { type: 'li', text: 'communicate with us in the context of a business relationship.' },
          { type: 'p', text: 'Depending on the nature of your request, the data may include:' },
          { type: 'li', text: 'first and last name;' },
          { type: 'li', text: 'email address;' },
          { type: 'li', text: 'telephone number;' },
          { type: 'li', text: 'postal address;' },
          { type: 'li', text: 'information relating to your request;' },
          { type: 'li', text: 'any other information you choose to share with us.' },
          { type: 'p', text: 'We may also process certain technical data generated automatically when you visit the site, such as IP address, browser type, operating system, date and time of visit, and pages visited.' },
        ],
      },
      {
        title: '3. Purposes of Processing',
        blocks: [
          { type: 'p', text: 'We process personal data only to the extent necessary, in particular to:' },
          { type: 'li', text: 'respond to your requests;' },
          { type: 'li', text: 'prepare and send offers or quotes;' },
          { type: 'li', text: 'provide our services;' },
          { type: 'li', text: 'manage our relationship with our clients and partners;' },
          { type: 'li', text: 'ensure the operation and security of the website;' },
          { type: 'li', text: 'improve our services and our online presence;' },
          { type: 'li', text: 'comply with our legal and regulatory obligations.' },
        ],
      },
      {
        title: '4. Contact Form',
        blocks: [
          { type: 'p', text: 'When you use the contact form available on our site, the information you enter is transmitted to Limpia Sàrl so that we can process your request.' },
          { type: 'p', text: 'Data provided through the form is not used for advertising purposes without an appropriate legal basis or, where required, without your consent.' },
          { type: 'p', text: 'We recommend that you do not send sensitive information through the form that is not necessary for processing your request.' },
        ],
      },
      {
        title: '5. Disclosure of Data to Third Parties',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl does not sell your personal data.' },
          { type: 'p', text: 'In the course of operating our website and our activities, certain data may be processed by external service providers when necessary, for example:' },
          { type: 'li', text: 'website hosting provider;' },
          { type: 'li', text: 'email service provider;' },
          { type: 'li', text: 'technical provider responsible for site maintenance;' },
          { type: 'li', text: 'analysis or statistics tools, when used;' },
          { type: 'li', text: 'other providers necessary for the delivery of our services.' },
          { type: 'p', text: 'These providers may process personal data only within the scope of their services and in accordance with applicable legal requirements.' },
          { type: 'p', text: 'When personal data is transferred to a country outside Switzerland or the European Economic Area, we ensure that the legal conditions applicable to such transfer are respected.' },
        ],
      },
      {
        title: '6. Cookies',
        blocks: [
          { type: 'p', text: 'Our website may use cookies and similar technologies to ensure its proper functioning, improve the user experience and, where applicable, obtain traffic statistics.' },
          { type: 'p', text: 'Cookies may allow the site to remember certain preferences or guarantee certain technical features.' },
          { type: 'p', text: 'When cookies or tracking technologies require your consent, it is requested in accordance with applicable legal requirements.' },
          { type: 'p', text: 'You can also configure your browser to limit or block certain cookies. However, disabling certain cookies may affect the functioning of the site.' },
        ],
      },
      {
        title: '7. Analytics Tools and External Services',
        blocks: [
          { type: 'p', text: 'If analysis, statistics, mapping, video or other external services are integrated into our site, they may process certain technical data relating to your use of the site.' },
          { type: 'p', text: 'The services actually used on the site are indicated in this privacy policy and, where necessary, in our cookie manager.' },
        ],
      },
      {
        title: '8. Retention Period',
        blocks: [
          { type: 'p', text: 'We retain personal data only for as long as necessary to achieve the purposes for which it was collected.' },
          { type: 'p', text: 'Where legal retention obligations exist, certain data may be retained for the period required by applicable law.' },
          { type: 'p', text: 'At the end of this period, the data is deleted or anonymized where technically possible and legally appropriate.' },
        ],
      },
      {
        title: '9. Data Security',
        blocks: [
          { type: 'p', text: 'We implement appropriate technical and organizational measures to protect personal data against loss, misuse, unauthorized access, alteration or disclosure.' },
          { type: 'p', text: 'However, no data transmission over the Internet or computer system can guarantee absolute security.' },
        ],
      },
      {
        title: '10. Your Rights',
        blocks: [
          { type: 'p', text: 'Within the limits provided by applicable law, you have the right in particular:' },
          { type: 'li', text: 'to request information about the personal data we process about you;' },
          { type: 'li', text: 'to request the correction of inaccurate personal data;' },
          { type: 'li', text: 'to request the deletion of your data when the legal conditions are met;' },
          { type: 'li', text: 'to object to certain processing of your data;' },
          { type: 'li', text: 'to request, where provided by law, the delivery or transmission of your data in an appropriate format.' },
          { type: 'p', text: 'To exercise your rights or obtain information regarding the processing of your personal data, you can contact us at the email address provided on our site.' },
        ],
      },
      {
        title: '11. Links to Third-Party Sites',
        blocks: [
          { type: 'p', text: 'Our site may contain links to websites operated by third parties.' },
          { type: 'p', text: 'Limpia Sàrl is not responsible for the content, privacy practices or data processing carried out by these third-party sites.' },
          { type: 'p', text: 'We recommend that you review the privacy policies of the sites concerned before providing them with personal data.' },
        ],
      },
      {
        title: '12. Changes to This Policy',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl may modify this privacy policy when necessary, in particular due to legal, technical or organizational changes.' },
          { type: 'p', text: 'The version published on our website is the applicable version.' },
        ],
      },
      {
        title: '13. Contact',
        blocks: [
          { type: 'p', text: 'For any questions regarding data protection or the use of your personal data, please contact:' },
          { type: 'p', text: 'Limpia Sàrl — Rte de Rosé 51, 1754 Avry-sur-Matran, Switzerland' },
          { type: 'p', text: 'Email: info@limpiasarl.ch' },
        ],
      },
    ],
  },
};